import { BigNumber } from '@ethersproject/bignumber';
import { parseUnits } from '@ethersproject/units';
import { PERCENT_DECIMALS } from '@silo/types';
import { toBigInt } from '@silo/utils';

export const APP_NAME_URL = 'silo.finance';
export const APP_NAME = 'SILO';
export const APP_SHORT_BLURB = 'Enabling lending and borrowing of any asset';
// temporarily pointing to the vercel deployment, to test out static assets
export const DEPLOYED_URL = 'https://teoiudfsjlj90j309dfjlsd309jf.vercel.app';

export const BIG_ZERO = BigNumber.from('0');
export const ONE_HUNDRED_PERCENT = parseUnits('1', PERCENT_DECIMALS);

export const CONVEX_POOL_ID = '0xf403c135812408bfbe8713b5a23a04b3d48aae31-129';
export const CONVEX_REWARDS_FEE_PERCENTAGE = 0.17;

export const DEFAULT_SILO_UCRIT = toBigInt('0.9', PERCENT_DECIMALS);

/**
 * August 22, 2022
 */
export const UI_DEPLOYMENT_DATE = new Date(2022, 7, 22);
